import { toCamelCase, toSnakeCase } from '../utils/caseConverter';
import { getApiHeaders } from '../utils/apiHeaders';
import { Customer } from '../types/Customer';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCustomers = (params?: { createdAt?: string; page?: number; limit?: number; search?: string }) => {
  const url = new URL(`${API_BASE_URL}/api/customers`);
  if (params?.createdAt) {
    url.searchParams.set('created_at', params.createdAt);
  }
  if (params?.page) {
    url.searchParams.set('page', params.page.toString());
  }
  if (params?.limit) {
    url.searchParams.set('limit', params.limit.toString());
  }
  if (params?.search?.trim()) {
    url.searchParams.set('search', params.search.trim());
  }
  return fetch(url.toString(), {
    headers: getApiHeaders('none'),
  }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function fetchCustomerById(customerId: number): Promise<Customer> {
  return fetch(`${API_BASE_URL}/api/customers/${customerId}`, {
      headers: getApiHeaders('none'),
    }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function createCustomer(data: Customer): Promise<{ id: number }> {
  const res = await fetch(`${API_BASE_URL}/api/customers`, {
    method: 'POST',
    headers: getApiHeaders('json'),
    body: JSON.stringify(toSnakeCase(data)),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create customer: ${errorText}`);
  }

  return res.json();
}
